import { merge } from '@/helpers/Utility';
import { FC } from 'react';

interface RosterPickerIconProps {
  name: string;
  active?: boolean;
}

export const RosterPickerIcon: FC<RosterPickerIconProps> = ({ name, active }) => {
  const names = name.split(' ')
  const initals = names.map(n => n.charAt(0).toUpperCase());
  const displayText = initals.join('');

  const colorClass = active ? 'bg-primary-500' : 'bg-gray-400';

  return (
    <div className={merge('rounded-full flex items-center justify-center w-8 h-8 p-2 text-sm', colorClass)}>
      <p className="text-white">{displayText || '-'}</p>
    </div>
  );
};
